import React, {useEffect, useState} from "react";
import BlogCard from "../blog/blogCard";
import client from "../../sanity/sanityClient";

const BlogList = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        client
            .fetch(
                `*[_type == "post"] | order(date desc) {
            title,
            slug,
            subtitle,
            "image": mainImage.asset->url,
                readTime,
          date, 
          author  
        }`
            )
            .then((data) => {
                setBlogs(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching blogs:", error);
                setLoading(false);
            });
    }, []);
    if (loading) {
        return (
            <section className="max-w-6xl mx-auto px-4 py-16">
                <p className="text-center text-gray-600">Loading blogs...</p>
            </section>
        );
    }
    if (blogs.length === 0) {
        return (
            <section className="max-w-6xl mx-auto px-4 py-16">
                <p className="text-center text-gray-600">No blogs found.</p>
            </section>
        );
    }
    return (
        <section className="max-w-6xl mx-auto px-4 py-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
                {blogs.map((item, index) => (
                    <BlogCard
                        key={item.slug?.current || index}
                        image={item.image}
                        readTime={item.readTime}
                        date={item.date}
                        title={item.title}
                        slug={item.slug?.current}
                    />
                ))}
            </div>
        </section>
    );
};

export default BlogList;
